import { canonicalLoomDefinitionJson } from "../features/parametric-geometry/loomAcceptedDefinitionBinding";
import {
  LOOM_TRANSITION_ACCEPTED_SCHEMA_V3,
  LOOM_TRANSITION_SOURCE_AUTHORITY,
  LOOM_TRANSITION_UNION_ALGORITHM_V3,
  verifyLoomAircraftTransitionAssetBuffer,
  type LoomVerifiedAircraftTransitionAsset,
} from "../features/parametric-geometry/loomAircraftTransitionAsset";
import type { LoomAuthoritativeRebuildRequestV6 } from "./loomRebuildV6";

export async function parseLoomRebuildV6Response(
  response: Response, buffer: ArrayBuffer, request: LoomAuthoritativeRebuildRequestV6,
  requiredHeader: (name: string) => string,
): Promise<{ assemblyAsset: LoomVerifiedAircraftTransitionAsset; definitionRevision: string }> {
  if (!response.headers.get("Content-Type")?.startsWith("application/vnd.loom.aircraft-occurrence-surface")
      || requiredHeader("X-Loom-Accepted-Schema") !== LOOM_TRANSITION_ACCEPTED_SCHEMA_V3
      || requiredHeader("X-Loom-Evaluator-Id") !== request.evaluatorId
      || requiredHeader("X-Loom-Union-Algorithm-Id") !== LOOM_TRANSITION_UNION_ALGORITHM_V3
      || requiredHeader("X-Loom-Source-Authority") !== LOOM_TRANSITION_SOURCE_AUTHORITY
      || requiredHeader("X-Loom-Wing-G2-Available") !== "false"
      || requiredHeader("X-Loom-Fuselage-G2-Available") !== "true"
      || requiredHeader("X-Loom-Continuity-Silent-Downgrade") !== "false") {
    throw new Error("Authoritative rebuild v6 response authority is unsupported");
  }
  const assemblyAsset = await verifyLoomAircraftTransitionAssetBuffer(buffer);
  if (assemblyAsset.header.version !== 3) throw new Error("Authoritative rebuild v6 asset version is unsupported");
  const header = assemblyAsset.header; const binding = header.definitionBinding;
  const definitionRevision = requiredHeader("X-Loom-Definition-Revision");
  if (requiredHeader("X-Loom-Geometry-Revision") !== header.surface.geometryRevision
      || requiredHeader("X-Loom-Topology-Revision") !== header.surface.topologyRevision
      || definitionRevision !== binding.definitionRevision
      || requiredHeader("X-Loom-Assembly-Topology-Revision") !== binding.assemblyTopologyRevision
      || requiredHeader("X-Loom-Pose-Revision") !== binding.poseRevision
      || requiredHeader("X-Loom-Scene-Revision") !== header.cacheReceipt.sceneRevision
      || Number(requiredHeader("X-Loom-Union-Group-Count")) !== header.unionGroups.length
      || Number(requiredHeader("X-Loom-Transition-Count")) !== header.transitions.length
      || canonicalLoomDefinitionJson(binding.definition) !== canonicalLoomDefinitionJson(request.definition)) {
    throw new Error("Authoritative rebuild v6 asset is not bound to the requested continuity head");
  }
  return { assemblyAsset, definitionRevision };
}
